import { useEffect, useState } from "react";
import { User } from "../types/User";
import { Users } from "../api/Users";
import { useAuth } from "../contexts/auth";
import { Roles } from "../enums/Roles";

type UserOption = { label: string; value: number };

// `enabled` gates the fetch: the assignable-users endpoint is admin-only, so
// athletes (read-only viewers) pass enabled=false to avoid a 401 → login bounce.
export function useAssignableUsers(enabled: boolean = true) {
  const { loggedUser } = useAuth();
  const [users, setUsers] = useState<UserOption[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!loggedUser || !enabled) return;

    const params = new URLSearchParams();

    // Trainer: solo i propri atleti (parentId = loggedUser.id)
    if (loggedUser.role === Roles.Trainer && loggedUser.id) {
      params.set("parentId", String(loggedUser.id));
    }
    // Superadmin: tutti gli utenti (nessun filtro parentId)

    setLoading(true);
    Users.getUsersForProgrammazioni(params)
      .then(({ data }) => {
        const options = (data.list || []).map((u: User) => ({
          label: `${u.nome} ${u.cognome}`,
          value: u.id!,
        }));
        setUsers(options);
      })
      .catch(() => {
        setUsers([]);
      })
      .finally(() => setLoading(false));
  }, [loggedUser, enabled]);

  return { users, loading };
}
